import React, { Component } from "react";
import "../../css/AiRpCommonAssets.css";
import "../../css/AiRpSignupOnboarding.css";

import http from "../modules/api";

class AiRpSignupOnboarding extends Component {

  constructor(props) {
    super(props);
    this.state = {
      settingList: [],
    };
  }

  componentDidMount() {
    this.fetchSettingList();
  }

  /**
   * 페이지 목록 조회
   */
  fetchSettingList = () => {
    http.get("/rest/shop/ai/rp/settingListByPageId", {
      params: {}
    })
    .then(res => {
      // 서버가 Map으로 내려준 구조 그대로 저장
      this.setState({
        settingList: res.data.setting_list ? res.data.setting_list : [],
      });
    })
    .catch(err => {
      this.setState({ loading: false, sync: false });
      alert("페이지 목록 조회 에러");
    });
  };

  render() {
    const { settingList } = this.state;

    const is_robomd_ai_main_page_use = settingList.some(
      slot => slot.iframe_page_id === "robomd_ai_main_page"
    );

    const is_robomd_ai_cart_page_use = settingList.some(
      slot => slot.iframe_page_id === "robomd_ai_cart_page"
    );

    const is_robomd_ai_order_complete_page_use = settingList.some(
      slot => slot.iframe_page_id === "robomd_ai_order_complete_page"
    );

    const is_robomd_ai_detail_page_use = settingList.some(
      slot => slot.iframe_page_id === "robomd_ai_detail_page"
    );  

    return (
      <div id='common-page-wrapper'>

        <div className="ai-rp-signup-onboarding">
          <div className="layout-wrapper">
            <main className="main-content">
              <div className="container">
                <div className="page-header">
                  <h1>
                    환영합니다! 매출을 올리는 AI, RoboMD 입니다.
                  </h1>
                  <p>
                    가입이 완료되었습니다. 쇼핑몰회원과 비회원의 체류활동까지 수집되는 AI 추천을 적용하여 2주간 무료로 성과를 확인해보세요.
                  </p>
                </div>
                <section className="card metrics-card">
                  <div className="metrics-header">
                    <h2>
                      이미 많은 기업들이 RoboMD로 성과를 내고 있습니다.
                    </h2>
                    <p>
                      RoboMD 도입 쇼핑몰들의 평균적인 AI 추천 성과입니다.
                    </p>
                  </div>
                  <div className="metrics-grid">
                    <div className="metric-item">
                      <p className="metric-label">
                        추천 페이지뷰
                      </p>
                      <p className="metric-value num-font">
                        148,359
                        <span className="metric-unit">
                          뷰
                        </span>
                      </p>
                    </div>
                    <div className="metric-item">
                      <p className="metric-label">
                        추천 실 노출수
                      </p>
                      <p className="metric-value num-font">
                        43,403
                        <span className="metric-unit">
                          건
                        </span>
                      </p>
                    </div>
                    <div className="metric-item">
                      <p className="metric-label">
                        추천 클릭수
                      </p>
                      <p className="metric-value num-font">
                        344
                        <span className="metric-unit">
                          건
                        </span>
                      </p>
                    </div>
                    <div className="metric-item">
                      <p className="metric-label">
                        추천 구매건수
                      </p>
                      <p className="metric-value num-font">
                        58
                        <span className="metric-unit">
                          건
                        </span>
                      </p>
                    </div>
                    <div className="metric-item">
                      <p className="metric-label">
                        추천 기여 매출
                      </p>
                      <p className="metric-value highlight num-font">
                        ₩ 9,571,708
                      </p>
                    </div>
                  </div>
                </section>
                <section className="card status-banner">
                  <div className="status-left">
                    <div className="status-icon-wrapper">
                      <div className="pulse-bg"></div>
                      <i className="fa-solid fa-download"></i>
                    </div>
                    <div className="status-text">
                      <h2>
                        AI 추천 정확도를 높이기 위한 방문 행동 분석 AI타겟뷰 앱 무료 설치
                        <span className="badge-essential">
                          설치 대기 중
                        </span>
                      </h2>
                      <p>
                        방문자의 상품 클릭, 체류시간, 관심 카테고리, 재방문 여부 등을 분석해
                        <strong style={{marginLeft: "4px"}}>
                          AI추천의 비회원 추천 정확도 향상에 사용됩니다.
                        </strong>
                      </p>
                    </div>
                  </div>
                  <div className="status-right">
                    <button className="btn-action-target" onClick={ () => { window.open("https://store.cafe24.com/kr/apps/22839","_blank") }}>
                      <i className="fa-brands fa-app-store-ios"></i>
                      AI타겟뷰 앱 무료 설치하기
                    </button>
                  </div>
                </section>
                <section>
                  <h2 className="section-title">
                    단 한 번의 설치로 경험하는 영역별 AI 추천 성과
                  </h2>
                  <div className="widget-grid">
                    <div className="widget-card">
                      <div>
                        <div className="w-icon w-icon-1">
                          <i className="fa-regular fa-file-lines"></i>
                        </div>
                        <h3 className="w-title">
                          상품 상세 (Item-Based CF)
                        </h3>
                        <p className="w-desc">
                          "이 상품을 본 고객이 함께 산 상품"을 딥러닝으로 매칭하여 추가 구매를 유도합니다.
                        </p>
                      </div>
                      <div className="w-footer">
                        <div className="w-effect">
                          <span className="e-label">
                            예상 추천 구매 전환율
                          </span>
                          <span className="e-val num-font">
                            30.00%
                          </span>
                        </div>
                        {
                          is_robomd_ai_detail_page_use
                          ? <button className="btn-install" disabled>
                            <i className="fa-solid fa-spinner fa-spin"></i>
                            설치 진행 중
                          </button>
                          : <button className="btn-install">
                            설치요청
                          </button>
                        }
                      </div>
                    </div>
                    <div className="widget-card">
                      <div>
                        <div className="w-icon w-icon-2">
                          <i className="fa-solid fa-cart-shopping"></i>
                        </div>
                        <h3 className="w-title">
                          장바구니 (Cross-Sell)
                        </h3>
                        <p className="w-desc">
                          장바구니 상품과 연관성이 높은 아이템을 제안하여 동시 구매율을 높입니다.
                        </p>
                      </div>
                      <div className="w-footer">
                        <div className="w-effect">
                          <span className="e-label">
                            예상 추천 구매 전환율
                          </span>
                          <span className="e-val num-font">
                            40.48%
                          </span>
                        </div>
                        {
                          is_robomd_ai_cart_page_use
                          ? <button className="btn-install" disabled>
                            <i className="fa-solid fa-spinner fa-spin"></i>
                            설치 진행 중
                          </button>
                          : <button className="btn-install">
                            설치요청
                          </button>
                        }
                      </div>
                    </div>
                    <div className="widget-card">
                      <div>
                        <div className="w-icon w-icon-3">
                          <i className="fa-solid fa-circle-check"></i>
                        </div>
                        <h3 className="w-title">
                          구매완료 (재구매 유도)
                        </h3>
                        <p className="w-desc">
                          결제 직후 고객의 취향을 분석해 다음 방문 시 구매할 가능성이 높은 상품을 노출합니다.
                        </p>
                      </div>
                      <div className="w-footer">
                        <div className="w-effect">
                          <span className="e-label">
                            예상 추천 구매 전환율
                          </span>
                          <span className="e-val num-font">
                            15.20%
                          </span>
                        </div>
                        {
                          is_robomd_ai_order_complete_page_use
                          ? <button className="btn-install" disabled>
                            <i className="fa-solid fa-spinner fa-spin"></i>
                            설치 진행 중
                          </button>
                          : <button className="btn-install">
                            설치요청
                          </button>
                        }
                      </div>
                    </div>
                    <div className="widget-card">
                      <div>
                        <div className="w-icon w-icon-4">
                          <i className="fa-solid fa-house"></i>
                        </div>
                        <h3 className="w-title">
                          메인 홈 (Best Seller)
                        </h3>
                        <p className="w-desc">
                          방문자의 관심 키워드와 연관된 상품을 분석하여 가장 구매 확률이 높은 상품을 보여줍니다.
                        </p>
                      </div>
                      <div className="w-footer">
                        <div className="w-effect">
                          <span className="e-label">
                            예상 추천 구매 전환율
                          </span>
                          <span className="e-val num-font">
                            9.76%
                          </span>
                        </div>
                        {
                          is_robomd_ai_main_page_use
                          ? <button className="btn-install" disabled>
                            <i className="fa-solid fa-spinner fa-spin"></i>
                            설치 진행 중
                          </button>
                          : <button className="btn-install">
                            설치요청
                          </button>
                        }
                      </div>
                    </div>
                  </div>
                </section>
                <section className="card onboarding-card">
                  <div className="step-container">
                    <div className="step-line"></div>
                    <div className="step-line-active"></div>
                    <div className="step-item active">
                      <div className="step-circle">
                        <i className="fa-solid fa-check"></i>
                      </div>
                      <div className="step-name">
                        회원 가입
                      </div>
                    </div>
                    <div className="step-item current">
                      <div className="step-circle num-font">
                        2
                      </div>
                      <div className="step-name">
                        AI타겟뷰 앱 설치
                      </div>
                    </div>
                    <div className="step-item">
                      <div className="step-circle num-font">
                        3
                      </div>
                      <div className="step-name">
                        AI 추천 설치 중
                      </div>
                    </div>
                    <div className="step-item">
                      <div className="step-circle num-font">
                        4
                      </div>
                      <div className="step-name">
                        무료 체험 (2주)
                      </div>
                    </div>
                    <div className="step-item">
                      <div className="step-circle num-font">
                        5
                      </div>
                      <div className="step-name">
                        도입 결정
                      </div>
                    </div>
                  </div>
                  <div className="action-area">
                    <button className="btn-action-install">
                      쇼핑몰 AI추천 설치 요청하기
                    </button>
                    <p className="helper-text">
                      언제든 설치를 요청하시면 담당자가 24시간 이내에 연락드려
                      <br />
                      설치 방법과 스크립트를 안내해 드립니다.
                    </p>
                  </div>
                </section>
              </div>
            </main>
          </div>
        </div>
      </div>
    );
  }
}

export default AiRpSignupOnboarding;
